import { BCBarcode, BCInput, BCNotification, EBarcodeTypes, findMessage } from '@bimser/components';
import { copyToClipboard } from '@bimser/core';
import IconCopy from '@bimser/icons/16/copy';
import 'bootstrap/dist/css/bootstrap-grid.min.css';
import * as React from 'react';
import qrScan from '../assets/img/qrScan.webp';
import Styles from '../assets/style.scss';
import IServerInfoWithQrComponentProps from '../entities/IServerInfoWithQrComponentProps';

const ServerInfoWithQr: React.FC<IServerInfoWithQrComponentProps> = props => {
	const onClickLoginPanel = () => {
		if (props.onClickLoginPanel) {
			props.onClickLoginPanel();
		}
	};

	const getQRValue = () => {
		const url = (window as any).serviceConfig.services.login.baseURL;
		const allurl = new URL((window as any).serviceConfig.services.login.baseURL).origin;

		const serverInfo = {
			serverNick: url.split('//')[1].split('.')[0],
			serverAddress: allurl,
			domainAddress: allurl,
			serverMainPath: url.split('//')[1].split('/').slice(1).join('/')
		};
		return JSON.stringify(serverInfo);
	};

	const onClickCopy = () => {
		const copyText = JSON.parse(getQRValue()).domainAddress;
		copyToClipboard(copyText);

		BCNotification.info({
			message: findMessage.get('101743')
		});
	};

	return (
		<div className={Styles.qrCodeContainer}>
			{!props.hideBackLink && (
				<div className={Styles.qrPageTitle}>{findMessage.get('102430')}</div>
			)}
			<div className={Styles.qrCodeLine}>
				<div className={Styles.qrScanImage}>
					<img src={qrScan} />
				</div>
				<div className={Styles.qrCode}>
					<BCBarcode
						codeType={EBarcodeTypes.QR}
						value={getQRValue()}
					/>
				</div>
				<div className={Styles.qrText}>
					<BCInput
						value={JSON.parse(getQRValue()).domainAddress}
						style={{ height: '24px', textAlign: 'center' }}
						readOnly
					/>
					<IconCopy
						height="24px"
						width="24px"
						onClick={onClickCopy}
					/>
				</div>
				<div className={Styles.qrExplain}>{findMessage.get('101930')}</div>
			</div>
			{!props.hideBackLink && (
				<span onClick={onClickLoginPanel}>{findMessage.get('100753')}</span>
			)}
		</div>
	);
};

export default ServerInfoWithQr;
